import { MDBBtn, MDBIcon } from "mdbreact";
import React from "react";
import Lightbox from "react-image-lightbox";
import { Link } from "react-router-dom";
import Select from 'react-select';
import { Card, CardBody, Col, Collapse, Form, Input, Label, Media, Row, Table } from "reactstrap";
import toastr from "toastr";
import ApiRest from "../../ayudas/apiRest";
import { MINUTOS, noMasOpciones, TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones";
import HistorialFormulario from "../../components/historial/historialFormulario";
import _valid from "../../validations";

export default class TareaFormulario extends React.Component {

    constructor(props) {
        super(props);
        const hayRegistro = _valid(props.datos);
        this.apiRest = new ApiRest(props);

        this.pathnameAnterior = props.pathnameAnterior

        this.state = {
            idRegistro: props.props,
            registro: hayRegistro ? props.datos.registro : {
                tarea_descripcion: "",
                tarea_nota: "",
                img_solicitud_tarea_trabajada: "",
                img_solicitud_tarea_trabajada_2: "",
                img_solicitud_tarea_trabajada_3: "",
                razon_rechazo: undefined,
                colaborador_que_acepta: undefined,
                activo_trabajado: undefined
            },
            comentario: "",
            modalEstaAbierto: false,
            colaborador_que_acepta: hayRegistro && _valid(props.datos.registro) && _valid(props.datos.registro.colaborador_que_acepta_seleccionado) ? props.datos.registro.colaborador_que_acepta_seleccionado : undefined,
            activo_trabajado: props.datos.registro.activo_trabajado_select,

            colapsar: true,
            imgSolicitudTrabajadaBase64: hayRegistro && _valid(props.datos.imgSolicitudTrabajadaBase64) ? props.datos.imgSolicitudTrabajadaBase64 : undefined,
            imgSolicitudTrabajadaBase64_2: hayRegistro && _valid(props.datos.imgSolicitudTrabajadaBase64_2) ? props.datos.imgSolicitudTrabajadaBase64_2 : undefined,
            imgSolicitudTrabajadaBase64_3: hayRegistro && _valid(props.datos.imgSolicitudTrabajadaBase64_3) ? props.datos.imgSolicitudTrabajadaBase64_3 : undefined,
            verImagenEnGrande: false,

            horas: 0,
            minutos: 0,

            colapsarColaborador: false,
            colapsarArticulo: true,

            colaboradoresInvolucrados: [],
            colaboradoresAceptan: [],
            articulos: [],
            activos: [],

            colaboradores_asociados: [],
            articulos_asociados: [],

            estado_original: props.datos.registro.estado,
            isButtonDisabled: false,
        };

        this.colapsarTablaAsociaciones = this.colapsarTablaAsociaciones.bind(this);

        this.agregarArticulo = this.agregarArticulo.bind(this);
        this.asociarArticulo = this.asociarArticulo.bind(this);

        this.agregarColaboradorInvolucrado = this.agregarColaboradorInvolucrado.bind(this);
        this.asociarInvolucrado = this.asociarInvolucrado.bind(this);

        this.actualizarImagen = this.actualizarImagen.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.actualizarValoresRegistro = this.actualizarValoresRegistro.bind(this);
        this.actualizarColaboradorQueAcepta = this.actualizarColaboradorQueAcepta.bind(this);
    }

    //========================================================
    // General
    //========================================================
    componentDidMount() {
        this.obtenerColaboradoresInvolucrados();
        this.obtenerColaboradoresAceptan();
        this.obtenerColaboradoresAsociados();

        this.obtenerMaterialesListado();
        this.obtenerActivosListado();
        this.obtenerArticulosAsociados();

        this.obtenerDatosSolicitudCompleta();
    }

    obtenerDatosSolicitudCompleta(id) {
        const idRegistro = this.state.idRegistro || id;
        if (!isNaN(idRegistro)) {
            this.apiRest.getWithFiles('/solicitud/' + idRegistro).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ registro: resultado.data, activo_trabajado: resultado.data.activo_trabajado_select, colaborador_que_acepta: resultado.data.colaborador_que_acepta_seleccionado });
                    if (_valid(resultado.imgSolicitudTrabajadaBase64)) {
                        this.setState({ imgSolicitudTrabajadaBase64: resultado.imgSolicitudTrabajadaBase64 })
                    }
                    if (_valid(resultado.imgSolicitudTrabajadaBase64_2)) {
                        this.setState({ imgSolicitudTrabajadaBase64_2: resultado.imgSolicitudTrabajadaBase64_2 })
                    }
                    if (_valid(resultado.imgSolicitudTrabajadaBase64_3)) {
                        this.setState({ imgSolicitudTrabajadaBase64_3: resultado.imgSolicitudTrabajadaBase64_3 })
                    }
                }
            });
        }
    }

    colapsarTablaAsociaciones = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
    }

    actualizarImagen = ({ target: { name, files } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: files[0] }
        }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [name]: value }));
    }

    actualizarValoresRegistro = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    //========================================================
    // Articulos
    //========================================================
    agregarArticulo = articulo => {
        if (articulo) {
            const datos = {
                cantidad: 1,
                articulo: articulo.id,
                solicitud: this.state.registro.id
            };

            this.apiRest.post('/asociarSolicitudArticulo', datos).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Material añadido exitosamente!');
                    this.obtenerArticulosAsociados();
                } else if (resultado.response.status === 400) {
                    toastr.error(resultado.data.mensaje);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    asociarArticulo(cantidad, articuloId, asociado) {
        cantidad = parseInt(cantidad);
        if (_valid(cantidad)) {
            const datos = {
                cantidad,
                articulo: articuloId,
                solicitud: this.state.registro.id
            };

            this.apiRest.put('/solicitudArticulo/' + asociado, datos).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Material actualizado exitosamente!');
                    this.obtenerArticulosAsociados();
                } else if (resultado.response.status === 400) {
                    toastr.error(resultado.data.mensaje);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            toastr.error("La cantidad mínima es 1.");
        }
    }

    eliminarSolicitudArticulo = idSoliArticulo => {
        this.apiRest.delete('/solicitudArticulo/' + idSoliArticulo).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Solicitud - Material eliminado exitosamente!');
                this.obtenerArticulosAsociados();
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensajeError);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //========================================================
    // Colaborador involucrado
    //========================================================
    agregarColaboradorInvolucrado = (colaborador) => {
        let id = _valid(colaborador) ? colaborador.value : null;
        if (_valid(id)){
            const datos = {
                colaborador: id,
                horas: 0,
                minutos: 1,
                solicitud: this.state.registro.id
            };

            this.apiRest.post('/asociarSolicitudColaborador', datos).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Colaborador involucrado se ha añadido / editado exitosamente!');
                    this.setState(
                        anterior => ({
                            ...anterior,
                            horas: resultado.data.horas,
                            minutos: resultado.data.minutos,
                            colaboradores_asociados: [...anterior.colaboradores_asociados, resultado.data]
                        })
                    );
                } else if (resultado.response.status === 400) {
                    toastr.error(resultado.data.mensaje);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    asociarInvolucrado(nombre, valor, colaborador, asociacion) {
        const { horas, minutos } = this.state;
        const esCampoHoras = nombre === "horas";
        let horas2, minutos2;
        let datos = {
            colaborador,
            solicitud: this.state.registro.id
        };
        if (esCampoHoras) {
            horas2 = parseInt(valor);
            horas2 = _valid(horas2) ? horas2 : 0;
            if (!_valid(horas2)) { // Ingresa si el campo horas tiene "0"
                if (!_valid(parseInt(minutos))) {
                    toastr.error('El tiempo (horas o minutos) es requerido. (Debe haber al menos 15 minutos)');
                    return;
                }
            }
            datos["horas"] = horas2;
            datos["minutos"] = minutos;
        } else {
            minutos2 = parseInt(valor);
            minutos2 = _valid(minutos2) ? minutos2 : 0;
            if (!_valid(parseInt(horas))) { // Ingresa si el campo horas tiene "0"
                if (!_valid(minutos2)) {
                    toastr.error('El tiempo (horas o minutos) es requerido. (Debe haber al menos 15 minutos)');
                    return;
                }
            }
            datos["horas"] = horas;
            datos["minutos"] = minutos2;
        }

        this.apiRest.put('/solicitudColaboradorDetalle/' + asociacion, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Colaborador involucrado se ha añadido / editado exitosamente!');
                if (esCampoHoras) {
                    this.setState(anterior => ({ ...anterior, horas: horas2 }));
                } else {
                    this.setState(anterior => ({ ...anterior, minutos: minutos2 }));
                }
                this.obtenerColaboradoresAsociados();
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensaje);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    eliminarSolicitudColaborador = idSoliColaborador => {
        this.apiRest.delete('/solicitudColaboradorDetalle/' + idSoliColaborador).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Solicitud - Colaborador eliminado exitosamente!');
                this.obtenerColaboradoresAsociados();
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensajeError);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    actualizarColaboradorQueAcepta = obj => {
        if (!obj) {
            obj = { colaborador: { id: null } }
        }

        this.setState(prev => ({
            colaborador_que_acepta: obj,
            registro: {
                ...prev.registro,
                colaborador_que_acepta: obj.colaborador.id
            }
        })
        );
    }

    setActivoTrabajado = activoTrabajado => {
        if (!activoTrabajado) {
            activoTrabajado = { id: null }
        }
        this.setState(estadoAnterior => ({
            activo_trabajado: activoTrabajado,
            registro: { ...estadoAnterior.registro, activo_trabajado: activoTrabajado.id }
        }));
    }

    actualizarValoresNumericos = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: parseInt(value) }
        }));
    }

    //========================================================
    // Obtener datos
    //========================================================
    obtenerColaboradoresAsociados() {
        this.apiRest.get('/solicitudesColaboradores/' + this.state.registro.id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ colaboradores_asociados: resultado.data });
            }
        });
    }

    obtenerArticulosAsociados() {
        this.apiRest.get('/solicitudesArticulos/' + this.state.registro.id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ articulos_asociados: resultado.data });
            }
        });
    }

    formatoColaboradores = valores => valores.data.map(i => ({ value: i.value, label: i.label+' /'+i.colaborador.departamento_area }));

    obtenerColaboradoresInvolucrados() {
        /*this.apiRest.get('/departamentoAreaColaboradorPorDepartamento/' + this.state.registro.solicitar_a).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ colaboradoresInvolucrados: resultado.data });
            }
        });*/
        this.apiRest.get('/departamentoColaboradorAsociarTarea/' + this.state.registro.solicitar_a).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ colaboradoresInvolucrados: this.formatoColaboradores(resultado)});
            }
        });
    }

    obtenerColaboradoresAceptan() {
        this.apiRest.get('/departamentoAreaColaboradorPorColaborador/' + this.state.registro.solicitante).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ colaboradoresAceptan: resultado.data });
            }
        });
        /*this.apiRest.get('/colaboradorListadoParaAsociar').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ colaboradoresAceptan: respuesta.data });
            }
        });*/
    }

    obtenerMaterialesListado() {
        this.apiRest.get('/materialesParaSelect').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ articulos: resultado.data });
            }
        });
    }

    obtenerActivosListado() {
        this.apiRest.get('/activosParaSelect').then(resultado => {
            if (resultado.exitoso) {
                //console.log(resultado.data);
                this.setState({ activos: resultado.data });
            }
        });
    }


    //========================================================
    // Envio de datos
    //========================================================
    /*almacenarRegistro(historialGuardado) {
        if (this.datosRegistroValidos()) {
            if (typeof (historialGuardado) === "boolean") {
                if (historialGuardado) {
                    this.enviarValores();
                }
                this.setState({ modalEstaAbierto: false });
            } else {
                this.setState({ modalEstaAbierto: true });
            }
        }
    }*/

    almacenarRegistro(historialGuardado) {
        if (this.datosRegistroValidos()) {
            const { registro } = this.state;
            this.setState({ isButtonDisabled: true });
            let datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_solicitud_tarea_trabajada", "img_solicitud_tarea_trabajada_2", "img_solicitud_tarea_trabajada_3");
            this.apiRest.putFiles('/solicitudActualizarTareaTrabajada/' + registro.id, datosFormulario).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Datos almacenados exitosamente!');
                    /*if (resultado.data.estado === 5) {
                        this.evirarCorreoRechazo(registro.id);
                    } else if (resultado.data.estado === 3) {
                        this.enviarCorreoFinalizado(registro.id)
                    }*/
                    this.setState({ registro: resultado.data, activo_trabajado: resultado.data.activo_trabajado_select, colaborador_que_acepta: resultado.data.colaborador_que_acepta_seleccionado });
                    if (_valid(resultado.imgSolicitudTrabajadaBase64)) {
                        this.setState({ imgSolicitudTrabajadaBase64: resultado.imgSolicitudTrabajadaBase64 });
                    }
                    if (_valid(resultado.imgSolicitudTrabajadaBase64_2)) {
                        this.setState({ imgSolicitudTrabajadaBase64_2: resultado.imgSolicitudTrabajadaBase64_2 });
                    }
                    if (_valid(resultado.imgSolicitudTrabajadaBase64_3)) {
                        this.setState({ imgSolicitudTrabajadaBase64_3: resultado.imgSolicitudTrabajadaBase64_3 });
                    }
                    //toastr.success("Solicitud actualizada exitosamente!");
                    this.guardarEnHistorial();
                    this.whatsappConcluirSolicitud(registro.id);
                    this.props.props.actualizarFila(registro.id);
                    this.props.props.changeSideAbierto();
                    this.concluirOdoo(registro.id);
                    //this.props.props.history.replace(this.pathnameAnterior);                    
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
                this.setState({ isButtonDisabled: false });
            });
        }
    }

    evirarCorreoRechazo = id => {
        this.apiRest.get('/correoRechazoSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado a colaborador solicitante.');
            }
        });
    }

    enviarCorreoFinalizado = id => {
        this.apiRest.get('/correoSolicitudFinalizada/' + id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Correo enviado a colaborador solicitante.');
            }
        });
    }

    whatsappConcluirSolicitud(id) {
        this.apiRest.get('/whatsappConcluirSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Whatsapp enviado exitosamente!');
            } else {
                console.log('Vaya! Ha ocurrido un error al enviar whatsapp, por favor intenta nuevamente.');
            }
        });
    }

    concluirOdoo(id) {
        this.apiRest.get('/concluirOdooSolicitud/' + id).then(resultado => {
            if (resultado.exitoso) {
                console.log('Concluir en Odoo exitosamente!');
            } else {
                console.log('No se pudo enviar la FECHA CONCLUIDO a Odoo');
                /*toastr.error('No se pudo enviar la FECHA CONCLUIDO a Odoo', id, {
                    timeOut: 0, closeButton: true, extendedTimeOut: 0, tapToDismiss: false,
                });*/
            }
        });
    }

    guardarEnHistorial(){
        const comentario = this.state.registro.tarea_descripcion;
        if (_valid(comentario)) {
            const { estado, id } = this.state.registro;
            let datos = { comentario };
            if (estado !== undefined) {
                datos["estado"] = parseInt(estado);
            }
            if (id) {
                datos["solicitud"] = id;
            }
            this.apiRest.post('/historial', datos).then(resultado => {
                if (resultado.exitoso) {
                    console.log("Se guardo el historial.");
                } else {
                    toastr.error("No se guardo comentario para el historial.");
                }
            });
        }
    }

    /*enviarValores = async () => {
        const { registro } = this.state;
        let datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_solicitud_tarea_trabajada");
        await this.apiRest.putFiles('/solicitudActualizarTareaTrabajada/' + registro.id, datosFormulario).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Datos almacenados exitosamente!');
                if (resultado.data.estado === 5) {
                    this.evirarCorreoRechazo(registro.id);
                } else if (resultado.data.estado === 3) {
                    this.enviarCorreoFinalizado(registro.id)
                }
                this.setState({ registro: resultado.data, activo_trabajado: resultado.data.activo_trabajado_select, colaborador_que_acepta: resultado.data.colaborador_que_acepta_seleccionado });
                if (_valid(resultado.imgSolicitudTrabajadaBase64)) {
                    this.setState({ imgSolicitudTrabajadaBase64: resultado.imgSolicitudTrabajadaBase64 });
                }
                this.props.props.actualizarFila(registro.id);
                this.props.props.changeSideAbierto();
                //this.props.props.history.replace(this.pathnameAnterior);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }*/

    datosRegistroValidos() {
        const { razon_rechazo, estado, tarea_descripcion, img_solicitud_tarea_trabajada, colaborador_que_acepta } = this.state.registro;
        
        if (estado === 5) {
            if (_valid(razon_rechazo, colaborador_que_acepta)) {
                return true;
            }
            if (!_valid(razon_rechazo)) {
                toastr.error("Razón de Rechazo es requerida.")
            }
            if (!_valid(colaborador_que_acepta)) {
                toastr.error("El colaborador que acepta es requerido.");
            }
        }
        else{
            if (_valid(tarea_descripcion, colaborador_que_acepta)) {
                return true;
            }
            if (!_valid(tarea_descripcion)) {
                toastr.error("la tarea realizada (descripción) es requerida.")
            }            
            if (!_valid(colaborador_que_acepta)) {
                toastr.error("El colaborador que acepta es requerido.");
            }
        }
        return false;
    }

    handleChange = ({ target: { name, value, checked } }) => {           
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, remoto: (checked) ? 1 : 0 }
        }));
    }

    render() {
        const {
            modalEstaAbierto,
            registro,
            colaborador_que_acepta,
            activo_trabajado,
            colapsar,
            colaboradoresInvolucrados,
            colaboradoresAceptan,
            articulos,
            activos,

            colapsarColaborador,
            colapsarArticulo,

            colaboradores_asociados,
            articulos_asociados,

            imgSolicitudTrabajadaBase64,
            imgSolicitudTrabajadaBase64_2,
            imgSolicitudTrabajadaBase64_3,
            verImagenEnGrande,
            estado_original,
        } = this.state;

        return (
            <div>
                <React.Fragment>
                    <Card style={registro.estado == 3 ? {background: "#FAFFFA"}:{background: "#fff"}}>
                        <CardBody>
                            <Link onClick={() => this.colapsarTablaAsociaciones("colapsar")} className="text-dark" to="#">
                                <div className="p-4">
                                    <Media className="d-flex align-items-center">
                                        <div className="me-3">
                                            <i className="uil uil-receipt text-primary h2"></i>
                                        </div>
                                        <div className="flex-1 overflow-hidden">
                                            <h5 className="font-size-16 mb-1">Tareas / Trabajos</h5>
                                            <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                        </div>
                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                    </Media>
                                </div>
                            </Link>
                            {
                                _valid(registro.id) &&
                                <Collapse isOpen={colapsar}>
                                    <div className="p-4 border-top">
                                        <Form>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label className="form-label">
                                                            Estado de Solicitud:
                                                        </Label>
                                                        <select
                                                            value={registro.estado}
                                                            onChange={this.actualizarValoresNumericos}
                                                            name="estado"
                                                            className="form-control"
                                                        >
                                                            <option key={1} value={1}>Asignado</option>
                                                            <option key={6} value={6}>En proceso</option>
                                                            {/*
                                                            {
                                                                (estado_original === 7 && registro.autorizado_listo != "listo" && registro.solicitar_a === 41) ?
                                                                <>                                                            
                                                                <option key={7} value={7}>Autorizado</option>                                                                
                                                                <option key={5} value={5}>Rechazado</option>
                                                                </>
                                                            : ''
                                                            }
                                                            {
                                                                (estado_original === 7 && registro.autorizado_listo === "listo" && registro.solicitar_a === 41) ?
                                                                <>                                                            
                                                                <option key={7} value={7}>Autorizado</option> 
                                                                <option key={3} value={3}>Concluido</option>                                                               
                                                                <option key={5} value={5}>Rechazado</option>
                                                                </>
                                                            : ''
                                                            }*/}
                                                            {
                                                                (registro.solicitar_a === 41) ?
                                                                <> 
                                                                <option key={7} value={7}>Autorizado</option>
                                                                <option key={3} value={3}>Concluido</option>                                                               
                                                                <option key={5} value={5}>Rechazado</option>
                                                                </>
                                                            : ''
                                                            }
                                                            {
                                                                (registro.solicitar_a != 41) ?
                                                                <> 
                                                                <option key={3} value={3}>Concluido</option>                                                               
                                                                <option key={5} value={5}>Rechazado</option>
                                                                </>
                                                            : ''
                                                            }

                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="colaborador_que_acepta" className="form-label">
                                                            {registro.estado === 5 ? 'Colaborador que Rechaza' : 'Colaborador que acepta'}
                                                        </Label>
                                                        <Select
                                                            name="colaborador_que_acepta"
                                                            value={colaborador_que_acepta}
                                                            options={colaboradoresAceptan}
                                                            onChange={this.actualizarColaboradorQueAcepta}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            placeholder="Seleccionar.."
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            hideSelectedOptions={true}
                                                            noOptionsMessage={noMasOpciones}
                                                        />
                                                    </div>
                                                </Col> 
                                                <Col lg={12}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="razon_rechazo" className="form-label">
                                                            {registro.estado === 5 ? ' Razón de Rechazo' : 'Trabajo o tarea realizada'}
                                                        </Label>
                                                        {
                                                            registro.estado === 5 ?
                                                                <Input
                                                                    value={registro.razon_rechazo}
                                                                    onChange={this.actualizarValoresRegistro}
                                                                    name="razon_rechazo"
                                                                    type="textarea"
                                                                    className="form-control"
                                                                    placeholder="Razón Rechazo"
                                                                /> :
                                                                <Input
                                                                    value={registro.tarea_descripcion}
                                                                    onChange={this.actualizarValoresRegistro}
                                                                    name="tarea_descripcion"
                                                                    type="textarea"
                                                                    className="form-control"
                                                                    placeholder="Tarea realizada"
                                                                />
                                                        }
                                                    </div>
                                                </Col>
                                                {
                                                    (registro.solicitar_a == 41) ? ( 
                                                        <>
                                                            <Col lg={12} className="text-center align-items-center justify-content-center">
                                                                <div className="mb-3 mb-4" style={{background: "#FFFDE6"}}>
                                                                    <Label className="form-label">
                                                                        Por mal uso
                                                                    </Label>
                                                                    {" "}
                                                                    <Input
                                                                        type="checkbox"
                                                                        value={registro.remoto}
                                                                        onChange={this.handleChange}
                                                                        defaultChecked={registro.remoto}
                                                                        className=""
                                                                    />
                                                                </div>
                                                                <div className="mb-3 mb-4" style={{background: "#FFFDE6"}}>
                                                                    <Label className="form-label">
                                                                        Se recomienda subir foto de tarea realizada
                                                                    </Label>
                                                                </div>

                                                            </Col> 
                                                        </>                                                   
                                                    ) : ''
                                                }
                                                { 
                                                    (registro.solicitar_a == 35) ? (
                                                        <Col lg={12} className="text-center align-items-center justify-content-center">
                                                            <div className="mb-3 mb-4" style={{background: "#FFFDE6"}}>
                                                                <Label className="form-label">
                                                                    Remoto
                                                                </Label>
                                                                {" "}
                                                                <Input
                                                                    type="checkbox"
                                                                    value={registro.remoto}
                                                                    onChange={this.handleChange}
                                                                    defaultChecked={registro.remoto}
                                                                    className=""
                                                                />
                                                            </div>
                                                        </Col>
                                                    ) : ''
                                                }                                               
                                                {
                                                    /*registro.estado === 5 && 
                                                    <Col lg={6}>
                                                        <label>
                                                            Razón de Rechazo
                                                        </label>
                                                        <p>{registro.razon_rechazo}</p>
                                                    </Col>*/
                                                }
                                            </Row>

                                            <Row>
                                                <Col lg={4}>
                                                    <div className="mb-2 mb-3">
                                                        <Label htmlFor="img_solicitud_tarea_trabajada" className="form-label">
                                                            Imagen 1
                                                        </Label>
                                                        <input
                                                            name="img_solicitud_tarea_trabajada"
                                                            className="form-control"
                                                            type="file"
                                                            onChange={this.actualizarImagen}
                                                        />
                                                    </div>
                                                </Col>                                                
                                                <Col lg={4}>
                                                    <div className="mb-2 mb-3">
                                                        <Label htmlFor="img_solicitud_tarea_trabajada_2" className="form-label">
                                                            Imagen 2
                                                        </Label>
                                                        <input
                                                            name="img_solicitud_tarea_trabajada_2"
                                                            className="form-control"
                                                            type="file"
                                                            onChange={this.actualizarImagen}
                                                        />
                                                    </div>
                                                </Col>                                                
                                                <Col lg={4}>
                                                    <div className="mb-2 mb-3">
                                                        <Label htmlFor="img_solicitud_tarea_trabajada_3" className="form-label">
                                                            Imagen 3
                                                        </Label>
                                                        <input
                                                            name="img_solicitud_tarea_trabajada_3"
                                                            className="form-control"
                                                            type="file"
                                                            onChange={this.actualizarImagen}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            {/*
                                                <Row>
                                                    <Col lg={6}>
                                                        <div className="mb-2 mb-3">
                                                            <Label htmlFor="img_solicitud_tarea_trabajada" className="form-label">
                                                                Subir imagen de la tarea realizada
                                                            </Label>
                                                            <input
                                                                name="img_solicitud_tarea_trabajada"
                                                                className="form-control"
                                                                type="file"
                                                                onChange={this.actualizarImagen}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                        <div className="mb-2 mb-3">
                                                            <Label htmlFor="img_solicitud_tarea_trabajada" className="form-label">
                                                                Imagen
                                                            </Label>
                                                            <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                                {imgSolicitudTrabajadaBase64 && <img width="100%" src={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64}`} alt="solicitud" />}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            */}
                                            
                                            {/* ASOCIAR COLABORADORES INVOLUCRADOS */}
                                            
                                            <Row>
                                                <Col className="col-12">
                                                    <Card style={registro.estado == 3 ? {background: "#FAFFFA"}:{background: "#fff"}}>
                                                        <CardBody>
                                                            <Link onClick={() => this.colapsarTablaAsociaciones("colapsarColaborador")} className="text-dark" to="#">
                                                                <div>
                                                                    <Media className="d-flex align-items-center">
                                                                        <div className="flex-1 overflow-hidden">
                                                                            <h5 className="font-size-16 mb-1">Información adicional</h5>
                                                                        </div>
                                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                                    </Media>
                                                                </div>
                                                            </Link>
                                                            <Collapse isOpen={colapsarColaborador}>
                                                                <div>
                                                                    {registro.estado === 5 ? '' :
                                                                        <div>
                                                                            <Row>
                                                                                <Col lg={12}>
                                                                                    <div className="mb-2 mb-3">
                                                                                        <Label className="form-label">
                                                                                            Colaboradores involucrados
                                                                                        </Label>
                                                                                        <Select
                                                                                            options={colaboradoresInvolucrados}
                                                                                            onChange={this.agregarColaboradorInvolucrado}
                                                                                            className="basic-single"
                                                                                            classNamePrefix="select"
                                                                                            placeholder="Selecciona.."
                                                                                            isClearable={true}
                                                                                            isSearchable={true}
                                                                                            hideSelectedOptions={true}
                                                                                            noOptionsMessage={noMasOpciones}
                                                                                        />
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            {
                                                                                _valid(colaboradores_asociados) && (
                                                                                    <Table className="table table-sm m-0">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Nombre del colaborador</th>
                                                                                                <th>Horas</th>
                                                                                                <th>Minutos</th>
                                                                                                <th>Quitar</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                                colaboradores_asociados.map(involucrado =>
                                                                                                    <tr key={involucrado.colaborador}>
                                                                                                        <td>{involucrado.nombre_colaborador}</td>
                                                                                                        <td>
                                                                                                            <Input
                                                                                                                value={involucrado.horas}
                                                                                                                onChange={({ target: { name, value } }) => this.asociarInvolucrado(name, value, involucrado.colaborador, involucrado.id)}
                                                                                                                name="horas"
                                                                                                                type="number"
                                                                                                                className="form-control"
                                                                                                            />
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            <select
                                                                                                                value={involucrado.minutos}
                                                                                                                onChange={({ target: { name, value } }) => this.asociarInvolucrado(name, value, involucrado.colaborador, involucrado.id)}
                                                                                                                name="minutos"
                                                                                                                className="form-control"
                                                                                                            >
                                                                                                                {MINUTOS.map(min => <option key={min.value} value={min.value}>{min.label}</option>)}
                                                                                                            </select>
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            <MDBBtn className="waves-effect" size="sm" color="danger" onClick={() => this.eliminarSolicitudColaborador(involucrado.id)}>
                                                                                                                <MDBIcon icon="fas fa-times" />
                                                                                                            </MDBBtn>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                )
                                                                                            }
                                                                                        </tbody>
                                                                                    </Table>
                                                                                )
                                                                            }
                                                                            <Row>
                                                                                <Col lg={6}>
                                                                                    <div className="mb-2 mb-3">
                                                                                        <Label className="form-label">
                                                                                            Materiales utilizados
                                                                                        </Label>
                                                                                        <Select
                                                                                            options={articulos}
                                                                                            onChange={this.agregarArticulo}
                                                                                            className="basic-single"
                                                                                            classNamePrefix="select"
                                                                                            placeholder="Selecciona.."
                                                                                            isClearable={true}
                                                                                            isSearchable={true}
                                                                                            hideSelectedOptions={true}
                                                                                            noOptionsMessage={noMasOpciones}
                                                                                        />
                                                                                    </div>
                                                                                    {
                                                                                        _valid(articulos_asociados) && (
                                                                                            <Table className="table table-sm m-0">
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th>Código</th>
                                                                                                        <th>Nombre, marca y serie del articulo</th>
                                                                                                        <th>Cantidad</th>
                                                                                                        <th>Quitar</th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    {
                                                                                                        articulos_asociados.map(articuloAsociado =>
                                                                                                            <tr key={articuloAsociado.id}>
                                                                                                                <td>{articuloAsociado.codigo_articulo}</td>
                                                                                                                <td>{articuloAsociado.nombre_articulo}</td>
                                                                                                                <td>
                                                                                                                    <Input
                                                                                                                        value={articuloAsociado.cantidad}
                                                                                                                        onChange={({ target: { value } }) => this.asociarArticulo(value, articuloAsociado.articulo, articuloAsociado.id)}
                                                                                                                        type="number"
                                                                                                                        className="form-control"
                                                                                                                    />
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <MDBBtn className="waves-effect" size="sm" color="danger" onClick={() => this.eliminarSolicitudArticulo(articuloAsociado.id)}>
                                                                                                                        <MDBIcon icon="fas fa-times" />
                                                                                                                    </MDBBtn>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        )
                                                                                                    }
                                                                                                </tbody>
                                                                                            </Table>
                                                                                        )
                                                                                    }
                                                                                </Col>
                                                                                <Col lg={6}>
                                                                                    <div className="mb-2 mb-3">
                                                                                        <Label htmlFor="activo_trabajado" className="form-label">
                                                                                            Activo Trabajado
                                                                                        </Label>
                                                                                        <Select
                                                                                            name="activo_trabajado"
                                                                                            value={activo_trabajado || registro.activo_trabajado}
                                                                                            options={activos}
                                                                                            onChange={this.setActivoTrabajado}
                                                                                            className="basic-single"
                                                                                            classNamePrefix="select"
                                                                                            placeholder="Seleccionar.."
                                                                                            isClearable={true}
                                                                                            isSearchable={true}
                                                                                            hideSelectedOptions={true}
                                                                                            noOptionsMessage={noMasOpciones}
                                                                                        />
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    }

                                                                    <Row>
                                                                        <Col lg={12}>
                                                                            <div className="mb-2 mb-3">
                                                                                <Label htmlFor="tarea_nota" className="form-label">
                                                                                    Nota
                                                                                </Label>
                                                                                <Input
                                                                                    value={registro.tarea_nota}
                                                                                    onChange={this.actualizarValoresRegistro}
                                                                                    name="tarea_nota"
                                                                                    type="textarea"
                                                                                    className="form-control"
                                                                                    placeholder="Escribir una nota"
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Collapse>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12}>
                                                    {/*<MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.props.history.replace(this.pathnameAnterior) }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}*/}
                                                    {
                                                        registro.estado === 3 ?
                                                            <MDBBtn className="waves-effect float-end" color="success" onClick={this.almacenarRegistro} disabled={this.state.isButtonDisabled}>
                                                                <MDBIcon icon="fas fa-user-check" /> {' '}
                                                                Concluir Solicitud
                                                            </MDBBtn> :
                                                            <MDBBtn className="waves-effect float-end" color="info" onClick={this.almacenarRegistro}>
                                                                <MDBIcon icon="fas fa-arrow-right" /> {' '}
                                                                Guardar
                                                            </MDBBtn>
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </Collapse>
                            }    
                        </CardBody>
                    </Card>
                </React.Fragment>
                {modalEstaAbierto && <HistorialFormulario
                    solicitud={registro.id}
                    estado={registro.estado}
                    estadoModal={modalEstaAbierto}
                    seGuardoEnHistorial={historialGuardado => this.almacenarRegistro(historialGuardado)}
                />}
                {verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgSolicitudTrabajadaBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />}
            </div >
        );
    }
}